export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  body: string | null;
  data: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export function notificationTypeLabel(type: string): string {
  return type.replaceAll("_", " ");
}

export function resolveNotificationPath(notification: Pick<NotificationItem, "type" | "data">): string | null {
  const data = notification.data;
  if (!data || typeof data !== "object") return null;

  const orderId = data.orderId;
  if (typeof orderId === "string") return `/orders?record=${orderId}`;

  const caseId = data.caseId;
  if (typeof caseId === "string") return `/cases?record=${caseId}`;

  if (notification.type === "order_new_paid") return "/fulfilment";

  return null;
}
